import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';

class BasicInformationContactDetails extends VenueRegistrationFormModal {
	constructor() {
		super({
			modalSelector: '#contact-details-form-modal',
			triggerSelectors: ['.js-basic-info-add-contact-details', '.js-basic-info-edit-contact-details'],
			stepsEndpointAttr: 'contact-details-steps-endpoint',
			submitEndpointAttr: 'contact-details-submit-endpoint',
			wrapperSelector: '.p-venue-registration-basic-info',
			sectionWrapperSelector: '.p-venue-registration-basic-info-wrapper',
			logPrefix: 'BasicInformationContactDetails'
		});
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: 1,
			formType: FormTypes.SectionForm,
			exitButtonLabel: 'Save and Exit',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Save and continue',
				alwaysVisible: true
			}
		};
	}
}

VenueRegistrationFormModal.boot(BasicInformationContactDetails);

export default BasicInformationContactDetails;
